export const Memo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
  >
    <path
      d="M9.5 0H2.5C1.53517 0 0.75 0.785167 0.75 1.75V14H11.25V1.75C11.25 0.785167 10.4648 0 9.5 0ZM10.0833 12.8333H1.91667V1.75C1.91667 1.428 2.178 1.16667 2.5 1.16667H9.5C9.822 1.16667 10.0833 1.428 10.0833 1.75V12.8333ZM3.08333 2.91667H8.91667V4.08333H3.08333V2.91667ZM3.08333 5.83333H8.91667V7H3.08333V5.83333ZM3.08333 8.75H6V9.91667H3.08333V8.75Z"
      fill="currentColor"
    />
  </svg>
);
